import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPhotoAddFailed = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 200,
	height: 140,
	viewBox: "0 0 200 140",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("rect", {
			width: 200,
			height: 140,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M89.1382 26.1623C69.7027 44.467 64.4613 58.2684 48.8132 66.5333C38.8632 71.7886 27.4076 75.6469 21.53 85.2424C0.121438 120.193 45.7558 148.941 75.1378 114.66C100.056 85.5876 138.265 153 174.637 98.1602C207.137 49.1608 140.637 -22.3407 89.1382 26.1623Z",
			fill: "#F0FAF8"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 89.6406,
			cy: 120.66,
			r: 6,
			fill: "#F0FAF8"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 40.6406,
			cy: 35.6602,
			r: 8,
			fill: "#F0FAF8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M97 73H121",
			stroke: "url(#paint0_linear_8280_29662)",
			strokeWidth: 6,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M97 91H121",
			stroke: "url(#paint1_linear_8280_29662)",
			strokeWidth: 6,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M105 37C105 39.7614 102.761 42 100 42C97.2386 42 95 39.7614 95 37C95 34.2386 97.2386 32 100 32C102.761 32 105 34.2386 105 37Z",
			fill: "url(#paint2_linear_8280_29662)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M89.1382 26.1623C69.7027 44.467 64.4613 58.2684 48.8132 66.5333C38.8632 71.7886 27.4076 75.6469 21.53 85.2424C0.121438 120.193 45.7558 148.941 75.1378 114.66C100.056 85.5876 138.265 153 174.637 98.1602C207.137 49.1608 140.637 -22.3407 89.1382 26.1623Z",
			fill: "#F0FAF8"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 89.6406,
			cy: 120.66,
			r: 6,
			fill: "#F0FAF8"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 40.6406,
			cy: 35.6602,
			r: 8,
			fill: "#F0FAF8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M100 30.5C121.815 30.5 139.5 48.1848 139.5 70C139.5 91.8153 121.815 109.5 100 109.5C78.1848 109.5 60.5 91.8153 60.5 70C60.5 48.1848 78.1848 30.5 100 30.5Z",
			fill: "url(#paint3_linear_8280_29662)",
			stroke: "url(#paint4_linear_8280_29662)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M95.3697 88.75H104.629C111.131 88.75 114.382 88.75 116.718 87.2179C117.729 86.5546 118.597 85.7024 119.272 84.7097C120.833 82.4168 120.833 79.2248 120.833 72.841V72.8409V72.8409C120.833 66.457 120.833 63.265 119.272 60.9721C118.597 59.9795 117.729 59.1272 116.718 58.4639C115.217 57.4794 113.338 57.1276 110.462 57.0018C109.089 57.0018 107.907 55.9806 107.638 54.6591C107.234 52.6768 105.462 51.25 103.403 51.25H96.5959C94.537 51.25 92.7642 52.6769 92.3605 54.6591C92.0913 55.9806 90.9095 57.0018 89.5368 57.0018C86.6605 57.1276 84.7818 57.4794 83.2811 58.4639C82.2701 59.1272 81.402 59.9795 80.7265 60.9721C79.166 63.265 79.166 66.457 79.166 72.8409C79.166 79.2248 79.166 82.4168 80.7265 84.7097C81.402 85.7024 82.2701 86.5546 83.2811 87.2179C85.6165 88.75 88.8676 88.75 95.3697 88.75Z",
			fill: "url(#paint5_linear_8280_29662)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M111.575 64.3198C110.616 64.3198 109.839 65.083 109.839 66.0244C109.839 66.9658 110.616 67.7289 111.575 67.7289H113.89C114.849 67.7289 115.626 66.9658 115.626 66.0244C115.626 65.083 114.849 64.3198 113.89 64.3198H111.575Z",
			fill: "url(#paint6_linear_8280_29662)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M100.001 64.3198C95.2067 64.3198 91.3203 68.1356 91.3203 72.8426C91.3203 77.5495 95.2067 81.3653 100.001 81.3653C104.795 81.3653 108.681 77.5495 108.681 72.8426C108.681 68.1356 104.795 64.3198 100.001 64.3198ZM100.001 67.7289C97.1244 67.7289 94.7925 70.0184 94.7925 72.8426C94.7925 75.6667 97.1244 77.9562 100.001 77.9562C102.877 77.9562 105.209 75.6667 105.209 72.8426C105.209 70.0184 102.877 67.7289 100.001 67.7289Z",
			fill: "url(#paint7_linear_8280_29662)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M137.333 93.9998C137.333 101.364 131.363 107.333 123.999 107.333C116.636 107.333 110.666 101.364 110.666 93.9998C110.666 86.636 116.636 80.6665 123.999 80.6665C131.363 80.6665 137.333 86.636 137.333 93.9998Z",
			fill: "#DB5543",
			stroke: "white",
			strokeWidth: 1.5,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M124 86.3335C124.552 86.3335 125 86.7812 125 87.3335V95.3335C125 95.8858 124.552 96.3335 124 96.3335C123.448 96.3335 123 95.8858 123 95.3335V87.3335C123 86.7812 123.448 86.3335 124 86.3335ZM124 98.3335C124.552 98.3335 125 98.7812 125 99.3335V100.667C125 101.219 124.552 101.667 124 101.667C123.448 101.667 123 101.219 123 100.667V99.3335C123 98.7812 123.448 98.3335 124 98.3335Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_8280_29662",
				x1: 97,
				y1: 73.5,
				x2: 121,
				y2: 73.5,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#250E62" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#4C1DC8"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint1_linear_8280_29662",
				x1: 97,
				y1: 91.5,
				x2: 121,
				y2: 91.5,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#250E62" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#4C1DC8"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint2_linear_8280_29662",
				x1: 100,
				y1: 32,
				x2: 100,
				y2: 42,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#250E62" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#471BBB"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint3_linear_8280_29662",
				x1: 100,
				y1: 30,
				x2: 100,
				y2: 110,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#865E9C" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#B69CC4"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint4_linear_8280_29662",
				x1: 100,
				y1: 30,
				x2: 100,
				y2: 110,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#865E9C" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#B69CC4"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint5_linear_8280_29662",
				x1: 99.9993,
				y1: 51.25,
				x2: 99.9993,
				y2: 88.75,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#6BCABA" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#ACE1D8"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint6_linear_8280_29662",
				x1: 103.473,
				y1: 64.3198,
				x2: 103.473,
				y2: 81.3653,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#250E62" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#471BBB"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint7_linear_8280_29662",
				x1: 103.473,
				y1: 64.3198,
				x2: 103.473,
				y2: 81.3653,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#250E62" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#471BBB"
				})]
			})
		] })
	]
});
const ForwardRef = forwardRef(SvgPhotoAddFailed);
export { ForwardRef as ReactComponent };
